/* TTS "in your size" cross-sell on the product page (sections/tts-in-size.liquid), 2026-09.

   Size source, in this order:
     1. the size the shopper selects on this page (theme variant change, any size, even a sold-out one:
        "this size is gone, but these are in stock in it")
     2. ?variant=<id> in the URL (the shopper came with a size already picked)
     3. the remembered size (window.TTSSizeMemory / localStorage "tts_size")
   No size: the section stays hidden.

   Products: other in-stock products of the collection (default /collections/sneaker) with that
   size, fetched through the Section Rendering API: the same section file rendered in the
   collection context (?section_id=tts-in-size) returns the theme's own product cards.
   Fewer than 2 other products: hidden. */
(function () {
  'use strict';

  if (window.customElements && customElements.get('tts-in-size')) return;

  var MIN = 35;
  var MAX = 47;
  // EU42 / EU 42 / EU42.5 / EU42,5 / EU42 2/3 / UE42 (Romanian storefront)
  var RE = /^\s*(?:EU|UE)?\s*(\d{2})(?:[.,](\d)|\s+(\d)\/(\d))?\s*$/i;

  function parse(value) {
    var m = RE.exec(String(value == null ? '' : value));
    if (!m) return null;
    var base = parseInt(m[1], 10);
    var frac = '';
    if (m[2]) frac = '.' + m[2];
    else if (m[3]) frac = ' ' + m[3] + '/' + m[4];
    if (base < MIN || base > MAX) return null;
    return { base: base, size: String(base) + frac, third: !!m[4] && m[4] === '3', half: !!m[4] && m[4] === '2' };
  }

  function rememberedSize() {
    try {
      if (window.TTSSizeMemory && typeof window.TTSSizeMemory.get === 'function') {
        var mem = window.TTSSizeMemory.get();
        return mem ? mem.size : null;
      }
    } catch (e) {
      /* fall through to storage */
    }
    try {
      var p = parse(window.localStorage.getItem('tts_size'));
      return p ? p.size : null;
    } catch (e) {
      return null;
    }
  }

  function readJSON(root, selector) {
    var el = root.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  class TTSInSize extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.variants = readJSON(this, 'script[data-tts-in-size-variants]') || {};
      this.productId = String(this.dataset.productId || '');
      this.limit = parseInt(this.dataset.limit || '4', 10) || 4;
      this.minCount = parseInt(this.dataset.min || '2', 10) || 2;
      this.cache = {};
      this.token = 0;
      this.size = null;

      this.heading = this.querySelector('[data-tts-in-size-heading]');
      this.link = this.querySelector('[data-tts-in-size-link]');
      this.linkText = this.querySelector('[data-tts-in-size-link-text]');
      this.list = this.querySelector('[data-tts-in-size-list]');
      this.status = this.querySelector('[data-tts-in-size-status]');

      this.onVariant = this.onVariant.bind(this);
      this.onMemory = this.onMemory.bind(this);
      document.addEventListener('tts:size-change', this.onMemory);
      this.bindVariantChange();

      var start = this.sizeFromUrl() || rememberedSize();
      if (start) this.show(start, false);
    }

    disconnectedCallback() {
      document.removeEventListener('tts:size-change', this.onMemory);
      if (this.unsubscribe) this.unsubscribe();
    }

    bindVariantChange() {
      var self = this;
      function bind() {
        /* pubsub.js / global.js declare these as top-level bindings, not window properties */
        try {
          /* global subscribe, PUB_SUB_EVENTS */
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
            self.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, self.onVariant);
            return true;
          }
        } catch (e) {
          /* not available */
        }
        return false;
      }
      if (!bind()) {
        document.addEventListener('DOMContentLoaded', bind, { once: true });
      }
    }

    sizeFromUrl() {
      try {
        var id = new URLSearchParams(window.location.search).get('variant');
        if (!id || !Object.prototype.hasOwnProperty.call(this.variants, id)) return null;
        var p = parse(this.variants[id]);
        return p ? p.size : null;
      } catch (e) {
        return null;
      }
    }

    onVariant(event) {
      var variant = event && event.data && event.data.variant;
      if (!variant || variant.id == null) return;
      var id = String(variant.id);
      if (!Object.prototype.hasOwnProperty.call(this.variants, id)) return;
      var p = parse(this.variants[id]);
      if (p) this.show(p.size, true);
    }

    onMemory(event) {
      var detail = event && event.detail;
      if (detail && detail.size) this.show(detail.size, true);
    }

    /* Filter values for one size. The Romanian storefront translates the values ("UE40", "EU40,5",
       "UE 40"), so it gets every spelling; values a storefront does not have are ignored by Shopify. */
    filterValues(size) {
      var nums = [size];
      if (size.indexOf('.') !== -1) nums.push(size.replace('.', ','));
      var prefixes = this.dataset.allSpellings === 'true' ? ['EU', 'UE', 'EU ', 'UE '] : ['EU'];
      var out = [];
      prefixes.forEach(function (pre) {
        nums.forEach(function (n) {
          var v = pre + n;
          if (out.indexOf(v) === -1) out.push(v);
        });
      });
      return out;
    }

    query(size, withSection) {
      var params = new URLSearchParams();
      var param = this.dataset.param || 'filter.v.option.méret';
      this.filterValues(size).forEach(function (v) {
        params.append(param, v);
      });
      if (this.dataset.availParam) params.append(this.dataset.availParam, this.dataset.availValue || '1');
      if (this.dataset.sort) params.set('sort_by', this.dataset.sort);
      if (withSection) params.set('section_id', this.dataset.section || 'tts-in-size');
      return this.dataset.url + '?' + params.toString();
    }

    /* Hungarian needs the right suffix after the number: "EU 40-ben", "EU 43-ban", "EU 45-ös".
       The locale gives two lists of 12: last digit 0-9, then thirds, then halves. */
    /* The size as it is printed: thirds as ⅓ / ⅔ (like the size tiles), and the decimal
       separator of the storefront language (data-decimal: "," on /ro, "." elsewhere). */
    display(size) {
      var text = String(size).replace(' 1/3', '\u2153').replace(' 2/3', '\u2154').replace(' 1/2', '.5');
      var sep = this.dataset.decimal === ',' ? ',' : '.';
      return text.replace('.', sep);
    }

    fill(template, size) {
      var text = String(template || '').replace('[size]', this.display(size));
      if (text.indexOf('[in]') === -1 && text.indexOf('[adj]') === -1) return text;
      var p = parse(size);
      var idx = 0;
      if (p && p.third) idx = 10;
      else if (p && p.half) idx = 11;
      else idx = parseInt(size.charAt(size.length - 1), 10) || 0;
      var pick = function (list) {
        var parts = String(list || '').split('|');
        return parts[idx] || parts[0] || '';
      };
      return text.replace('[in]', pick(this.dataset.suffixIn)).replace('[adj]', pick(this.dataset.suffixAdj));
    }

    show(size, announce) {
      if (!size || size === this.size) return;
      this.size = size;
      var token = ++this.token;

      if (this.heading) this.heading.textContent = this.fill(this.dataset.heading, size);
      if (this.linkText) this.linkText.textContent = this.fill(this.dataset.link, size);
      if (this.link) this.link.setAttribute('href', this.query(size, false));

      if (this.cache[size]) {
        this.render(this.cache[size], announce);
        return;
      }

      this.skeleton();
      this.hidden = false;

      var self = this;
      fetch(this.query(size, true), { credentials: 'same-origin' })
        .then(function (r) {
          return r.ok ? r.text() : '';
        })
        .then(function (html) {
          if (token !== self.token) return;
          var items = [];
          if (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            doc.querySelectorAll('[data-tts-in-size-item]').forEach(function (el) {
              if (items.length >= self.limit) return;
              if (String(el.getAttribute('data-product-id')) === self.productId) return;
              items.push(el);
            });
          }
          self.cache[size] = items;
          self.render(items, announce);
        })
        .catch(function () {
          if (token !== self.token) return;
          self.hidden = true;
          if (self.list) self.list.setAttribute('aria-busy', 'false');
        });
    }

    skeleton() {
      if (!this.list) return;
      var html = '';
      for (var i = 0; i < this.limit; i++) {
        html +=
          '<li class="tts-in-size__item tts-in-size__item--skeleton" aria-hidden="true">' +
          '<span class="tts-in-size__sk-media"></span>' +
          '<span class="tts-in-size__sk-line"></span>' +
          '<span class="tts-in-size__sk-line tts-in-size__sk-line--short"></span>' +
          '</li>';
      }
      this.list.innerHTML = html;
      this.list.setAttribute('aria-busy', 'true');
    }

    render(items, announce) {
      if (!this.list) return;
      this.list.setAttribute('aria-busy', 'false');
      if (!items || items.length < this.minCount) {
        this.list.innerHTML = '';
        this.hidden = true;
        return;
      }
      this.list.innerHTML = '';
      var list = this.list;
      items.forEach(function (el) {
        list.appendChild(document.importNode(el, true));
      });
      this.hidden = false;
      if (announce && this.status && this.heading) {
        var status = this.status;
        var text = this.heading.textContent;
        status.textContent = '';
        window.setTimeout(function () {
          status.textContent = text;
        }, 60);
      }
    }
  }

  customElements.define('tts-in-size', TTSInSize);
})();
